import React from 'react';
import { Icon } from './Icon.js';
export const IconDuplicate2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M8.17066 16.0001L9.90383 22.4609L22.4609 19.0963L19.0962 6.53925L16 7.36887", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M3 3L3 16L16 16L16 3L3 3Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconDuplicate2.js.map